export class SliderChangeEvent<T> {
  public source: T;

  public value: number | null;
}

export class RangeSliderChangeEvent<T> {
  public source: T;

  public value: RangeSliderValue;
}

export type RangeSliderValue = [number, number] | null;
